module.exports = __webpack_public_path__ + "img/zmbg.820c2650.png";